<template>
  <div id="payBank">
    <div class="wrapper">
      <mainHeader class="mainHeader"></mainHeader>
      <div class="content">
        <div class="tip">
          <span>银行汇款支付成功后，我们会尽快为您审核，通过短信形式通知 审核进度(如已经支付订单，无需重复操作)。</span>
        </div>
        <div class="title">
          <img src="../assets/icon_pay_bank.png" />&nbsp;&nbsp;银行汇款
        </div>
        <div class="company">
          <div class="info" v-for="(value,index) in infos" :key="index">
            <div class="left">{{value.title}}</div>
            <div class="right" v-show="index<3">{{value.value}}</div>
            <div class="right" v-show="index===3">{{orderID}}</div>
          </div>
        </div>
      </div>
      <bottomButton title="汇款成功" :state="1" @click="payClick"></bottomButton>

      <successView :show="showSuccess" type="1" @successViewClick="successViewClick"></successView>
    </div>
  </div>
</template>

<script>
import mainHeader from '../view/header'
import bottomButton from '../components/bottom-button'
import successView from '../components/success-view'
export default {
  data () {
    return {
      successFlag: true,
      showSuccess: false,
      numb: 0,
      infos: [
        { title: '公司名称：', value: '中消在线有限公司' },
        { title: '开户银行：', value: '交通银行上海第一支行' },
        { title: '银行账号：', value: '310066726018800051881' },
        { title: '订单编号：', value: '' }
      ],
      orderID: '', // 订单id
      type: '' // 银行汇款项目 类型 1 中消通 2 安全管家 3 风险评测一键解决 4 应急保障下单详情页 6 订单详情页
    }
  },
  methods: {
    payClick () {
      this.successFlag = true
      // this.utils.POST(this.companyUrl + '/zxOrder/update/' + this.$route.query.orderID, null, response => {
      //   console.log('银行汇款提交成功------------------')
      //   sessionStorage.removeItem('orderid') // 一键解决
      //   this.showSuccess = true
      // })
    },
    successViewClick: function () {
      this.showSuccess = false
      if (parseInt(this.type) === 1) {
        this.$router.push({ path: 'zx-tong' })
      }
      if (parseInt(this.type) === 2) {
        this.$router.push({ path: 'safe-manager' })
      }
      if (parseInt(this.type) === 3) {
        this.$router.push({ path: 'home' })
      }
      if (parseInt(this.type) === 4) {
        this.$router.replace({ path: 'emergency-support' })
      }
      if (parseInt(this.type) === 5) {
        this.$router.go(-1)
      }
    }
  },
  watch: {
    $router: {
    }
  },
  components: { // 注册组件
    mainHeader,
    bottomButton,
    successView
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('clearOrderId', '')
    if (to.path === '/checkOrder') {
      next({
        path: '/orderListCenter',
        query: {
          status: 4,
          tag: 0
        }
      })
    } else {
      next()
    }
  },
  mounted () {
    this.orderID = this.$route.query.orderID
    console.log('orderID-----------------' + this.orderID)
    this.type = this.$route.query.type
  }
}
</script>

<style scoped>
#payBank {
  position: absolute;
  top: 55px;
  bottom: 0px;
  background-color: #f6f6f6;
  width: 100%;
}
.wrapper {
  position: relative;
}
.mainHeader {
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
}
.content {
  width: 100%;
  height: 260px;
  background-color: #ffffff;
}
.content .tip {
  position: relative;
  font-size: 13px;
  color: #bebebe;
  height: 62px;
  margin: 0 15px 15px 15px;
  border-bottom: solid 1px #eeeeee;
  padding-top: 15px;
  box-sizing: border-box;
  line-height: 16px;
}
.content .tip span {
}
.content .title {
  position: relative;
  margin-left: 15px;
  font-size: 16px;
  color: #000000;
  height: 40px;
  line-height: 40px;
}
.content .title img {
  position: relative;
  top: 5px;
  width: 20px;
  height: 20px;
}
.content .company {
  position: relative;
  top: 10px;
  height: 90px;
  width: 100%;
}
.content .company .info {
  position: relative;
  height: 30px;
}
.content .company .info {
  position: relative;
  height: 30px;
  font-size: 15px;
}
.content .company .info .left {
  position: absolute;
  left: 15px;
  height: 30px;
  color: #000000;
}
.content .company .info .right {
  position: absolute;
  left: 100px;
  height: 30px;
  color: #808080;
}
</style>



// WEBPACK FOOTER //
// src/components/pay-bank.vue